// class CountryStateCityService {
//     async fetchCountries() {
//         const headers = new Headers();
//         headers.append("X-CSCAPI-KEY", "Z3ozNkNIbG45UEpGUWtnaXRhTThuQXg2OTJiTmt1VFNkemVOcW14SA==");
    
//         const requestOptions = {
//             method: 'GET',
//             headers: headers,
//             redirect: 'follow'
//         };
    
//         try {
//             const response = await fetch("https://api.countrystatecity.in/v1/countries", requestOptions);
//             const result = await response.json();
//             return result;
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//             return [];
//         }
//     }

//     async fetchStatesByCountry(countryCode) {
//         const headers = new Headers();
//         headers.append("X-CSCAPI-KEY", "Z3ozNkNIbG45UEpGUWtnaXRhTThuQXg2OTJiTmt1VFNkemVOcW14SA==");
    
//         const requestOptions = {
//             method: 'GET',
//             headers: headers,
//             redirect: 'follow'
//         };
    
//         try {
//             const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states`, requestOptions);
//             const result = await response.json();
//             return result;
//         } catch (error) {
//             console.error('Error fetching states:', error);
//             return [];
//         }
//     }

//     async fetchCitiesByState(countryCode, stateCode) {
//         const headers = new Headers();
//         headers.append("X-CSCAPI-KEY", "Z3ozNkNIbG45UEpGUWtnaXRhTThuQXg2OTJiTmt1VFNkemVOcW14SA==");
    
//         const requestOptions = {
//             method: 'GET',
//             headers: headers,
//             redirect: 'follow'
//         };
    
//         try {
//             const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`, requestOptions);
//             const result = await response.json();
//             return result;
//         } catch (error) {
//             console.error('Error fetching cities:', error);
//             return [];
//         }
//     }
    
// }

// export default CountryStateCityService;


class CountryStateCityService {
    //#baseUrl = window.config.VUE_APP_COUNTRYSTATECITY_API_URL|| process.env.VUE_APP_COUNTRYSTATECITY_API_URL;
    //#apiKey =  process.env.VUE_APP_COUNTRYSTATECITY_API_KEY
    #baseUrl = "https://api.countrystatecity.in/v1/";
    #apiKey = "Z3ozNkNIbG45UEpGUWtnaXRhTThuQXg2OTJiTmt1VFNkemVOcW14SA==";

    async fetchFromApi(endpoint) {
    
        const headers = new Headers({
            "X-CSCAPI-KEY": this.#apiKey
        });

        const requestOptions = {
            method: "GET",
            headers: headers,
            redirect: "follow"
        };

        try {
            const response = await fetch(`${this.#baseUrl}${endpoint}`, requestOptions);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error(error); 
            return [];
        }
    }

    async fetchCountries() {
        return this.fetchFromApi("countries");
    }

    async fetchStatesByCountry(countryCode) {
        if (!countryCode) {
            throw new Error("countryCode is required");
        }
        return this.fetchFromApi(`countries/${countryCode}/states`);
    }

    async fetchCitiesByState(countryCode, stateCode) {
        if (!countryCode || !stateCode) {
            throw new Error("countryCode and stateCode are required");
        }
        return this.fetchFromApi(`countries/${countryCode}/states/${stateCode}/cities`);
    }
}


export default CountryStateCityService;
